import { FC, ReactNode } from "react";
import styles from "./Chips.module.scss";
import { SvgCross } from "../../icons/SvgCross";
import { P45 } from "../Typography";
import { useWindowResizeObserver } from "../../../hooks/useWindowResizeObserver";

interface IChips {
  children: ReactNode;
  onClick: () => void;
}
export const Chips: FC<IChips> = ({ children, onClick }) => {
  const { isMobile } = useWindowResizeObserver();
  return (
    <button className={styles.chips} onClick={isMobile ? onClick : undefined}>
      <P45>{children}</P45>
      <SvgCross onClick={isMobile ? undefined : onClick} />
    </button>
  );
};
